import ScrollableContainer from '@src/components/common/container/ScrollableContainer';
import LemonIcon from '@src/components/common/image/LemonIcon';
import withLocalize, { IWithLocalizeOwnProps } from '@src/components/common/localize/withLocalize';
import ViewSectionItem from '@src/components/common/section/ViewSectionItem';
import HeaderTitle from '@src/components/course/common/HeaderTitle';
import { IColumnChartData, TimunColumnChart } from '@src/components/externalEducationApplication/statistics/charts/TimunColumnChart';
import { IAveragePerExpenseType } from '@src/model/externalEducationApplication/ExternalEducationApplicationStatistics';
import { ExpeneseTypeEnum } from '@src/model/externalEducationExpense/ExternalEducationExpense';
import NumberFormatService from '@src/service/util/numberformat/NumberFormatService';
import React from 'react';

interface IEducationApplicationStatisticsExpensesOwnProps {
  averagePerExpenseTypes: IAveragePerExpenseType[];
}

type IEducationApplicationStatisticsExpensesProps = IEducationApplicationStatisticsExpensesOwnProps & IWithLocalizeOwnProps;

const EducationApplicationStatisticsExpenses = (props: IEducationApplicationStatisticsExpensesProps) => {
  const expensesByTypeData: IColumnChartData[] = [];
  props.averagePerExpenseTypes.forEach((averageExpenseType: IAveragePerExpenseType) => {
    const expenseName = Object.keys(ExpeneseTypeEnum).find((expense) => ExpeneseTypeEnum[expense as keyof typeof ExpeneseTypeEnum] === averageExpenseType.type.id);
    expensesByTypeData.push({
      label: props.translate(`EXTERNAL_EDUCATION_APPLICATION.EXPENSE.${expenseName}`),
      value: NumberFormatService.roundNumberCurrency(averageExpenseType.average),
    });
  });
  return (
    <ViewSectionItem
      header={<HeaderTitle title={props.translate('EXTERNAL_EDUCATION_APPLICATION_STATISTICS.STATISTICS_AVERAGE_EXPENSES_TITLE')} icon={<LemonIcon name="coins" size="large" />} />}
      collapsible={false}
      active={true}
      bordered={true}
    >
      <ScrollableContainer>
        <TimunColumnChart data={expensesByTypeData} />
      </ScrollableContainer>
    </ViewSectionItem>
  );
};

export default withLocalize<IEducationApplicationStatisticsExpensesOwnProps>(EducationApplicationStatisticsExpenses as any);
